export const makeAnalyticsSourceID = v => v;
export const SCREEN_EVENT_TYPE = 'screen';